<template>
  <div
    :style="{
      backgroundColor: section.styles.backgroundColor || '#ffffff',
      padding: section.styles.padding || '60px 20px',
      textAlign: section.styles.textAlign || 'center',
    }"
  >
    <div class="max-w-5xl mx-auto">
      <h2 v-if="section.content.title" class="text-3xl font-bold text-gray-900 mb-3">{{ section.content.title }}</h2>
      <p v-if="section.content.subtitle" class="text-lg text-gray-600 mb-10">{{ section.content.subtitle }}</p>
      <div class="grid gap-6 md:grid-cols-3">
        <div
          v-for="(item, index) in section.content.items || []"
          :key="index"
          class="rounded-xl border border-gray-200 bg-white p-6 shadow-sm"
        >
          <div
            class="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg"
            :style="{ backgroundColor: 'color-mix(in srgb, var(--lp-primary-color, #10b981) 15%, white)', color: 'var(--lp-primary-color, #10b981)' }"
          >
            <icon :name="item.icon || 'tick'" class="h-5 w-5" />
          </div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">{{ item.title }}</h3>
          <p class="text-sm text-gray-600 leading-relaxed">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon.vue'

export default {
  components: { Icon },
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
}
</script>
